import { render } from "./ClientCard.vue?vue&type=template&id=24986604"
import script from "./ClientCard.vue?vue&type=script&lang=js"
export * from "./ClientCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__